import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Form,
  FormGroup,
  FormField,
  Input,
  Dropdown,
  Button
} from 'semantic-ui-react'

const CardDrugResuscitationEditUX = (props: any) => {
    return(
      <div
        id="CardDrugResuscitationEditUX-div-0"
        style={{  margin: "20px"}}>
        <Form
          id="CardDrugResuscitationEditUX-Form-135">
          <FormGroup
            id="CardDrugResuscitationEditUX-FormGroup-136"
            inline={true}>
            <FormField
              id="CardDrugResuscitationEditUX-FormField-137"
              inline={true}
              width="5">
              <label
                id="CardDrugResuscitationEditUX-label-139">
                {props.languageUX === "en" ? "Code" : "Code"}
              </label>
              <div
                id="CardDrugResuscitationEditUX-div-138"
                style={{  width: "100%", padding: "8px", backgroundColor: "rgba(128, 128, 128, 0.5)"}}>
                {props.editData?.drugDetail?.code || ""}
              </div>
            </FormField>
            <FormField
              id="CardDrugResuscitationEditUX-FormField-140"
              inline={true}
              width="5">
              <label
                id="CardDrugResuscitationEditUX-label-142">
                {props.languageUX === "en" ? "Trade" : "Trade"}
              </label>
              <div
                id="CardDrugResuscitationEditUX-div-144"
                style={{  width: "100%", padding: "8px", backgroundColor: "rgba(128, 128, 128, 0.5)"}}>
                {props.editData?.drugDetail?.name || ""}
              </div>
            </FormField>
            <FormField
              id="CardDrugResuscitationEditUX-FormField-141"
              inline={true}
              width="6">
              <label
                id="CardDrugResuscitationEditUX-label-143">
                {props.languageUX === "en" ? "Generic" : "Generic"}
              </label>
              <div
                id="CardDrugResuscitationEditUX-div-145"
                style={{  width: "100%", padding: "8px", backgroundColor: "rgba(128, 128, 128, 0.5)"}}>
                {props.editData?.drugDetail?.generic_name || ""}
              </div>
            </FormField>
          </FormGroup>
          <FormGroup
            id="CardDrugResuscitationEditUX-FormGroup-146"
            inline={true}>
            <FormField
              id="CardDrugResuscitationEditUX-FormField-149"
              inline={true}
              width="5">
              <div
                id="CardDrugResuscitationEditUX-div-186"
                style={{display: "flex" }}>
                
                <label
                  id="CardDrugResuscitationEditUX-label-187">
                   Quantity
                </label>
                <label
                  id="CardDrugResuscitationEditUX-label-188"
                  style={{ color: "red"}}>
                  *
                </label>
              </div>
              <div
                id="CardDrugResuscitationEditUX-div-177"
                style={{ width: "100%", padding: "0px 10px"}}>
                
                <Input
                  id="CardDrugResuscitationEditUX-Input-182"
                  name="quantity"
                  onChange={props.onChangeData}
                  value={props.editData?.quantity || ""}>
                </Input>
              </div>
            </FormField>
            <FormField
              id="CardDrugResuscitationEditUX-FormField-150"
              inline={true}
              width="5">
              <div
                id="CardDrugResuscitationEditUX-div-189">
                
                <label
                  id="CardDrugResuscitationEditUX-label-190">
                  {props.languageUX === "en" ? "Dose" : "ปริมาณยา"}
                </label>
                <label
                  id="CardDrugResuscitationEditUX-label-191"
                  style={{ color: "red"}}>
                  *
                </label>
              </div>
              <div
                id="CardDrugResuscitationEditUX-div-180"
                style={{ width: "100%", padding: "0px 10px"}}>
                
                <Input
                  id="CardDrugResuscitationEditUX-Input-181"
                  name="dose"
                  onChange={props.onChangeData}
                  value={props.editData?.dose || ""}>
                </Input>
              </div>
            </FormField>
            <FormField
              id="CardDrugResuscitationEditUX-FormField-151"
              inline={true}
              width="6">
              <div
                id="CardDrugResuscitationEditUX-div-192">
                
                <label
                  id="CardDrugResuscitationEditUX-label-193">
                  {props.languageUX === "en" ? "Unit" : "หน่วย"}
                </label>
                <label
                  id="CardDrugResuscitationEditUX-label-194"
                  style={{ color: "red" }}>
                  *
                </label>
              </div>
              <div
                id="CardDrugResuscitationEditUX-div-184"
                style={{ width: "100%", padding: "0px 10px"}}>
                
                <Dropdown
                  fluid={true}
                  id="CardDrugResuscitationEditUX-Dropdown-185"
                  name="unit"
                  onChange={props.onChangeData}
                  options={props.unitOptions}
                  search={true}
                  selection={true}
                  value={props.editData?.unit || ""}>
                </Dropdown>
              </div>
            </FormField>
          </FormGroup>
          <FormGroup
            id="CardDrugResuscitationEditUX-FormGroup-147"
            inline={true}>
            <FormField
              id="CardDrugResuscitationEditUX-FormField-152"
              inline={true}
              width="8">
              <label
                id="CardDrugResuscitationEditUX-label-166">
                {props.languageUX === "en" ? "Route" : "ช่องทาง"}
              </label>
              <div
                id="CardDrugResuscitationEditUX-div-195"
                style={{ width: "100%", padding: "0px 10px"}}>
                
                <Dropdown
                  fluid={true}
                  id="CardDrugResuscitationEditUX-Dropdown-197"
                  name="route"
                  onChange={props.onChangeData}
                  options={props.masterOptions?.route}
                  search={true}
                  selection={true}
                  value={props.editData?.route || ""}>
                </Dropdown>
              </div>
            </FormField>
            <FormField
              id="CardDrugResuscitationEditUX-FormField-153"
              inline={true}
              width="8">
              <label
                id="CardDrugResuscitationEditUX-label-160">
                {props.languageUX === "en" ? "Site" : "ตำแหน่ง"}
              </label>
              <div
                id="CardDrugResuscitationEditUX-div-196"
                style={{ width: "100%", padding: "0px 10px"}}>
                
                <Dropdown
                  fluid={true}
                  id="CardDrugResuscitationEditUX-Dropdown-198"
                  name="site"
                  onChange={props.onChangeData}
                  options={props.masterOptions?.site}
                  search={true}
                  selection={true}
                  value={props.editData?.site || ""}>
                </Dropdown>
              </div>
            </FormField>
          </FormGroup>
          <FormGroup
            id="CardDrugResuscitationEditUX-FormGroup-216"
            inline="true">
            <FormField
              id="CardDrugResuscitationEditUX-FormField-217"
              inline="true"
              width="8">
              <div
                id="CardDrugResuscitationEditUX-div-219">
                
                <label
                  id="CardDrugResuscitationEditUX-label-223">
                  {props.languageUX === "en" ? "Frequency" : "Frequency"}
                </label>
              </div>
              <div
                id="CardDrugResuscitationEditUX-div-220"
                style={{ width: "100%", padding: "0px 10px"}}>
                
                <Dropdown
                  fluid={true}
                  id="CardDrugResuscitationEditUX-Dropdown-226"
                  name="frequency"
                  onChange={props.onChangeData}
                  options={props.masterOptions?.frequency}
                  search={true}
                  selection={true}
                  value={props.editData?.frequency || ""}>
                </Dropdown>
              </div>
            </FormField>
            <FormField
              id="CardDrugResuscitationEditUX-FormField-218"
              inline="true"
              width="8">
              <div
                id="CardDrugResuscitationEditUX-div-221">
                
                <label
                  id="CardDrugResuscitationEditUX-label-225">
                  {props.languageUX === "en" ? "Method" : "วิธี"}
                </label>
              </div>
              <div
                id="CardDrugResuscitationEditUX-div-222"
                style={{ width: "100%", padding: "0px 10px"}}>
                
                <Dropdown
                  fluid={true}
                  id="CardDrugResuscitationEditUX-Dropdown-227"
                  name="method"
                  onChange={props.onChangeData}
                  options={props.masterOptions?.method}
                  search={true}
                  selection={true}
                  value={props.editData?.method || ""}>
                </Dropdown>
              </div>
            </FormField>
          </FormGroup>
          <FormGroup
            id="CardDrugResuscitationEditUX-FormGroup-148"
            inline={true}>
            <FormField
              id="CardDrugResuscitationEditUX-FormField-154"
              inline={true}
              width="8">
              <div
                id="CardDrugResuscitationEditUX-div-199">
                
                <label
                  id="CardDrugResuscitationEditUX-label-204">
                  {props.languageUX === "en" ? "Nurse" : "พยาบาล"}
                </label>
                <label
                  id="CardDrugResuscitationEditUX-label-203"
                  style={{ color: "red" }}>
                  *
                </label>
              </div>
              <div
                id="CardDrugResuscitationEditUX-div-200"
                style={{ width: "100%", padding: "0px 10px"}}>
                
                <Input
                  id="CardDrugResuscitationEditUX-Input-207"
                  name="employeeCode"
                  onChange={props.onChangeData}
                  onKeyDown={props.handleKeyDown}
                  placeholder={props.languageUX === "en" ? "Code" : "รหัส"}
                  value={props.editData?.employeeCode || ""}>
                </Input>
              </div>
            </FormField>
            <FormField
              id="CardDrugResuscitationEditUX-FormField-155"
              inline={true}
              width="8">
              <div
                id="CardDrugResuscitationEditUX-div-201">
                
                <label
                  id="CardDrugResuscitationEditUX-label-205">
                  {props.languageUX === "en" ? "Time" : "เวลา"}
                </label>
                <label
                  id="CardDrugResuscitationEditUX-label-206"
                  style={{  color: "red" }}>
                  *
                </label>
              </div>
              <div
                id="CardDrugResuscitationEditUX-div-213">
                {props.time}
              </div>
            </FormField>
          </FormGroup>
        </Form>
        <div
          id="CardDrugResuscitationEditUX-div-124"
          style={{ display: "flex", justifyContent: "space-between"  }}>
          
          <div
            id="CardDrugResuscitationEditUX-div-125">
            
          </div>
          <div
            id="CardDrugResuscitationEditUX-div-126"
            style={{ display: "flex" }}>
            
            <div
              id="CardDrugResuscitationEditUX-div-215">
              {props.onSaveEdit}
            </div>
            <Button
              color="red"
              id="CardDrugResuscitationEditUX-Button-210"
              onClick={props.onCancel}>
              {props.languageUX === "en" ? "Cancel" : "ยกเลิก"}
            </Button>
          </div>
        </div>
      </div>
    )
}


export default CardDrugResuscitationEditUX

export const screenPropsDefault = {"debug":true,"language":"EN","showSupplyList":false}

/* Date Time : Fri Oct 31 2025 04:20:17 GMT+0000 (Coordinated Universal Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugResuscitationEditUX-div-0"
        },
        "style": {
          "type": "code",
          "value": "{  margin: \"20px\"}"
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 124,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugResuscitationEditUX-div-124"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", justifyContent: \"space-between\"  }"
        }
      },
      "seq": 135,
      "void": false
    },
    {
      "from": null,
      "id": 125,
      "name": "div",
      "parent": 124,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugResuscitationEditUX-div-125"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 125,
      "void": false
    },
    {
      "from": null,
      "id": 126,
      "name": "div",
      "parent": 124,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugResuscitationEditUX-div-126"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\" }"
        }
      },
      "seq": 126,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 135,
      "name": "Form",
      "parent": 0,
      "props": {
        "className": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugResuscitationEditUX-Form-135"
        }
      },
      "seq": 124,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 136,
      "name": "FormGroup",
      "parent": 135,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugResuscitationEditUX-FormGroup-136"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 136,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 137,
      "name": "FormField",
      "parent": 136,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugResuscitationEditUX-FormField-137"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "value",
          "value": "5"
        }
      },
      "seq": 137,
      "void": false
    },
    {
      "from": null,
      "id": 138,
      "name": "div",
      "parent": 137,
      "props": {
        "children": {
          "type": "code",
          "value": "props.editData?.drugDetail?.code || \"\""
        },
        "id": {
          "type": "value",
          "value": "CardDrugResuscitationEditUX-div-138"
        },
        "style": {
          "type": "code",
          "value": "{  width: \"100%\", padding: \"8px\", backgroundColor: \"rgba(128, 128, 128, 0.5)\"}"
        }
      },
      "seq": 139,
      "void": false
    },
    {
      "from": null,
      "id": 139,
      "name": "label",
      "parent": 137,
      "props": {
        "children": {
          "type": "value",
          "value": "Code",
          "valueEN": "Code"
        },
        "id": {
          "type": "value",
          "value": "CardDrugResuscitationEditUX-label-139"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 138,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 140,
      "name": "FormField",
      "parent": 136,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugResuscitationEditUX-FormField-140"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "value",
          "value": "5"
        }
      },
      "seq": 140,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 141,
      "name": "FormField",
      "parent": 136,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugResuscitationEditUX-FormField-141"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "value",
          "value": "6"
        }
      },
      "seq": 141,
      "void": false
    },
    {
      "from": null,
      "id": 142,
      "name": "label",
      "parent": 140,
      "props": {
        "children": {
          "type": "value",
          "value": "Trade",
          "valueEN": "Trade"
        },
        "id": {
          "type": "value",
          "value": "CardDrugResuscitationEditUX-label-142"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 142,
      "void": false
    },
    {
      "from": null,
      "id": 143,
      "name": "label",
      "parent": 141,
      "props": {
        "children": {
          "type": "value",
          "value": "Generic",
          "valueEN": "Generic"
        },
        "id": {
          "type": "value",
          "value": "CardDrugResuscitationEditUX-label-143"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 143,
      "void": false
    },
    {
      "from": null,
      "id": 144,
      "name": "div",
      "parent": 140,
      "props": {
        "children": {
          "type": "code",
          "value": "props.editData?.drugDetail?.name || \"\""
        },
        "id": {
          "type": "value",
          "value": "CardDrugResuscitationEditUX-div-144"
        },
        "style": {
          "type": "code",
          "value": "{  width: \"100%\", padding: \"8px\", backgroundColor: \"rgba(128, 128, 128, 0.5)\"}"
        }
      },
      "seq": 144,
      "void": false
    },
    {
      "from": null,
      "id": 145,
      "name": "div",
      "parent": 141,
      "props": {
        "children": {
          "type": "code",
          "value": "props.editData?.drugDetail?.generic_name || \"\""
        },
        "id": {
          "type": "value",
          "value": "CardDrugResuscitationEditUX-div-145"
        },
        "style": {
          "type": "code",
          "value": "{  width: \"100%\", padding: \"8px\", backgroundColor: \"rgba(128, 128, 128, 0.5)\"}"
        }
      },
      "seq": 145,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 146,
      "name": "FormGroup",
      "parent": 135,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugResuscitationEditUX-FormGroup-146"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 146,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 147,
      "name": "FormGroup",
      "parent": 135,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugResuscitationEditUX-FormGroup-147"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 147,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 148,
      "name": "FormGroup",
      "parent": 135,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugResuscitationEditUX-FormGroup-148"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 216,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 149,
      "name": "FormField",
      "parent": 146,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugResuscitationEditUX-FormField-149"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "value",
          "value": "5"
        }
      },
      "seq": 149,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 150,
      "name": "FormField",
      "parent": 146,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugResuscitationEditUX-FormField-150"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "value",
          "value": "5"
        }
      },
      "seq": 150,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 151,
      "name": "FormField",
      "parent": 146,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugResuscitationEditUX-FormField-151"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "value",
          "value": "6"
        }
      },
      "seq": 151,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 152,
      "name": "FormField",
      "parent": 147,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugResuscitationEditUX-FormField-152"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "value",
          "value": "8"
        }
      },
      "seq": 152,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 153,
      "name": "FormField",
      "parent": 147,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugResuscitationEditUX-FormField-153"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "value",
          "value": "8"
        }
      },
      "seq": 153,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 154,
      "name": "FormField",
      "parent": 148,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugResuscitationEditUX-FormField-154"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "value",
          "value": "8"
        }
      },
      "seq": 154,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 155,
      "name": "FormField",
      "parent": 148,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugResuscitationEditUX-FormField-155"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "value",
          "value": "8"
        }
      },
      "seq": 155,
      "void": false
    },
    {
      "from": null,
      "id": 160,
      "name": "label",
      "parent": 153,
      "props": {
        "children": {
          "type": "value",
          "value": "ตำแหน่ง",
          "valueEN": "Site"
        },
        "id": {
          "type": "value",
          "value": "CardDrugResuscitationEditUX-label-160"
        }
      },
      "seq": 160,
      "void": false
    },
    {
      "from": null,
      "id": 166,
      "name": "label",
      "parent": 152,
      "props": {
        "children": {
          "type": "value",
          "value": "ช่องทาง",
          "valueEN": "Route"
        },
        "id": {
          "type": "value",
          "value": "CardDrugResuscitationEditUX-label-166"
        }
      },
      "seq": 166,
      "void": false
    },
    {
      "from": null,
      "id": 177,
      "name": "div",
      "parent": 149,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugResuscitationEditUX-div-177"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\", padding: \"0px 10px\"}"
        }
      },
      "seq": 186,
      "void": false
    },
    {
      "from": null,
      "id": 180,
      "name": "div",
      "parent": 150,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugResuscitationEditUX-div-180"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\", padding: \"0px 10px\"}"
        }
      },
      "seq": 189,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 181,
      "name": "Input",
      "parent": 180,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugResuscitationEditUX-Input-181"
        },
        "name": {
          "type": "value",
          "value": "dose"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "value": {
          "type": "code",
          "value": "props.editData?.dose || \"\""
        }
      },
      "seq": 181,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 182,
      "name": "Input",
      "parent": 177,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugResuscitationEditUX-Input-182"
        },
        "name": {
          "type": "value",
          "value": "quantity"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "value": {
          "type": "code",
          "value": "props.editData?.quantity || \"\""
        }
      },
      "seq": 182,
      "void": false
    },
    {
      "from": null,
      "id": 184,
      "name": "div",
      "parent": 151,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugResuscitationEditUX-div-184"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\", padding: \"0px 10px\"}"
        }
      },
      "seq": 192,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 185,
      "name": "Dropdown",
      "parent": 184,
      "props": {
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDrugResuscitationEditUX-Dropdown-185"
        },
        "name": {
          "type": "value",
          "value": "unit"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "open": {
          "type": "value",
          "value": ""
        },
        "options": {
          "type": "code",
          "value": "props.unitOptions"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.editData?.unit || \"\""
        }
      },
      "seq": 185,
      "void": false
    },
    {
      "from": null,
      "id": 186,
      "name": "div",
      "parent": 149,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugResuscitationEditUX-div-186"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\" }"
        }
      },
      "seq": 177,
      "void": false
    },
    {
      "from": null,
      "id": 187,
      "name": "label",
      "parent": 186,
      "props": {
        "children": {
          "type": "value",
          "value": " Quantity"
        },
        "id": {
          "type": "value",
          "value": "CardDrugResuscitationEditUX-label-187"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 187,
      "void": false
    },
    {
      "from": null,
      "id": 188,
      "name": "label",
      "parent": 186,
      "props": {
        "children": {
          "type": "value",
          "value": "*"
        },
        "id": {
          "type": "value",
          "value": "CardDrugResuscitationEditUX-label-188"
        },
        "style": {
          "type": "code",
          "value": "{ color: \"red\"}"
        }
      },
      "seq": 188,
      "void": false
    },
    {
      "from": null,
      "id": 189,
      "name": "div",
      "parent": 150,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugResuscitationEditUX-div-189"
        }
      },
      "seq": 180,
      "void": false
    },
    {
      "from": null,
      "id": 190,
      "name": "label",
      "parent": 189,
      "props": {
        "children": {
          "type": "value",
          "value": "ปริมาณยา",
          "valueEN": "Dose"
        },
        "id": {
          "type": "value",
          "value": "CardDrugResuscitationEditUX-label-190"
        }
      },
      "seq": 190,
      "void": false
    },
    {
      "from": null,
      "id": 191,
      "name": "label",
      "parent": 189,
      "props": {
        "children": {
          "type": "value",
          "value": "*"
        },
        "id": {
          "type": "value",
          "value": "CardDrugResuscitationEditUX-label-191"
        },
        "style": {
          "type": "code",
          "value": "{ color: \"red\"}"
        }
      },
      "seq": 191,
      "void": false
    },
    {
      "from": null,
      "id": 192,
      "name": "div",
      "parent": 151,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugResuscitationEditUX-div-192"
        }
      },
      "seq": 184,
      "void": false
    },
    {
      "from": null,
      "id": 193,
      "name": "label",
      "parent": 192,
      "props": {
        "children": {
          "type": "value",
          "value": "หน่วย",
          "valueEN": "Unit"
        },
        "id": {
          "type": "value",
          "value": "CardDrugResuscitationEditUX-label-193"
        }
      },
      "seq": 193,
      "void": false
    },
    {
      "from": null,
      "id": 194,
      "name": "label",
      "parent": 192,
      "props": {
        "children": {
          "type": "value",
          "value": "*"
        },
        "id": {
          "type": "value",
          "value": "CardDrugResuscitationEditUX-label-194"
        },
        "style": {
          "type": "code",
          "value": "{ color: \"red\" }"
        }
      },
      "seq": 194,
      "void": false
    },
    {
      "from": null,
      "id": 195,
      "name": "div",
      "parent": 152,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugResuscitationEditUX-div-195"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\", padding: \"0px 10px\"}"
        }
      },
      "seq": 195,
      "void": false
    },
    {
      "from": null,
      "id": 196,
      "name": "div",
      "parent": 153,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugResuscitationEditUX-div-196"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\", padding: \"0px 10px\"}"
        }
      },
      "seq": 196,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 197,
      "name": "Dropdown",
      "parent": 195,
      "props": {
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDrugResuscitationEditUX-Dropdown-197"
        },
        "name": {
          "type": "value",
          "value": "route"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "options": {
          "type": "code",
          "value": "props.masterOptions?.route"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.editData?.route || \"\""
        }
      },
      "seq": 197,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 198,
      "name": "Dropdown",
      "parent": 196,
      "props": {
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDrugResuscitationEditUX-Dropdown-198"
        },
        "name": {
          "type": "value",
          "value": "site"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "options": {
          "type": "code",
          "value": "props.masterOptions?.site"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.editData?.site || \"\""
        }
      },
      "seq": 198,
      "void": false
    },
    {
      "from": null,
      "id": 199,
      "name": "div",
      "parent": 154,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugResuscitationEditUX-div-199"
        }
      },
      "seq": 199,
      "void": false
    },
    {
      "from": null,
      "id": 200,
      "name": "div",
      "parent": 154,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugResuscitationEditUX-div-200"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\", padding: \"0px 10px\"}"
        }
      },
      "seq": 200,
      "void": false
    },
    {
      "from": null,
      "id": 201,
      "name": "div",
      "parent": 155,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugResuscitationEditUX-div-201"
        }
      },
      "seq": 201,
      "void": false
    },
    {
      "from": null,
      "id": 203,
      "name": "label",
      "parent": 199,
      "props": {
        "children": {
          "type": "value",
          "value": "*"
        },
        "id": {
          "type": "value",
          "value": "CardDrugResuscitationEditUX-label-203"
        },
        "style": {
          "type": "code",
          "value": "{ color: \"red\" }"
        }
      },
      "seq": 204,
      "void": false
    },
    {
      "from": null,
      "id": 204,
      "name": "label",
      "parent": 199,
      "props": {
        "children": {
          "type": "value",
          "value": "พยาบาล",
          "valueEN": "Nurse"
        },
        "id": {
          "type": "value",
          "value": "CardDrugResuscitationEditUX-label-204"
        }
      },
      "seq": 203,
      "void": false
    },
    {
      "from": null,
      "id": 205,
      "name": "label",
      "parent": 201,
      "props": {
        "children": {
          "type": "value",
          "value": "เวลา",
          "valueEN": "Time"
        },
        "id": {
          "type": "value",
          "value": "CardDrugResuscitationEditUX-label-205"
        }
      },
      "seq": 205,
      "void": false
    },
    {
      "from": null,
      "id": 206,
      "name": "label",
      "parent": 201,
      "props": {
        "children": {
          "type": "value",
          "value": "*"
        },
        "id": {
          "type": "value",
          "value": "CardDrugResuscitationEditUX-label-206"
        },
        "style": {
          "type": "code",
          "value": "{  color: \"red\" }"
        }
      },
      "seq": 206,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 207,
      "name": "Input",
      "parent": 200,
      "props": {
        "disabled": {
          "type": "code",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugResuscitationEditUX-Input-207"
        },
        "name": {
          "type": "value",
          "value": "employeeCode"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "onKeyDown": {
          "type": "code",
          "value": "props.handleKeyDown"
        },
        "placeholder": {
          "type": "value",
          "value": "รหัส",
          "valueEN": "Code"
        },
        "readOnly": {
          "type": "code",
          "value": ""
        },
        "value": {
          "type": "code",
          "value": "props.editData?.employeeCode || \"\""
        }
      },
      "seq": 207,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 210,
      "name": "Button",
      "parent": 126,
      "props": {
        "children": {
          "type": "value",
          "value": "ยกเลิก",
          "valueEN": "Cancel"
        },
        "className": {
          "type": "value",
          "value": ""
        },
        "color": {
          "type": "value",
          "value": "red"
        },
        "id": {
          "type": "value",
          "value": "CardDrugResuscitationEditUX-Button-210"
        },
        "onClick": {
          "type": "code",
          "value": "props.onCancel"
        }
      },
      "seq": 215,
      "void": false
    },
    {
      "from": null,
      "id": 213,
      "name": "div",
      "parent": 155,
      "props": {
        "children": {
          "type": "code",
          "value": "props.time"
        },
        "id": {
          "type": "value",
          "value": "CardDrugResuscitationEditUX-div-213"
        },
        "style": {
          "type": "value",
          "value": ""
        }
      },
      "seq": 213,
      "void": false
    },
    {
      "from": null,
      "id": 215,
      "name": "div",
      "parent": 126,
      "props": {
        "children": {
          "type": "code",
          "value": "props.onSaveEdit"
        },
        "id": {
          "type": "value",
          "value": "CardDrugResuscitationEditUX-div-215"
        }
      },
      "seq": 209,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 216,
      "name": "FormGroup",
      "parent": 135,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugResuscitationEditUX-FormGroup-216"
        },
        "inline": {
          "type": "value",
          "value": "true"
        }
      },
      "seq": 148,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 217,
      "name": "FormField",
      "parent": 216,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugResuscitationEditUX-FormField-217"
        },
        "inline": {
          "type": "value",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "width": {
          "type": "value",
          "value": "8"
        }
      },
      "seq": 217,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 218,
      "name": "FormField",
      "parent": 216,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugResuscitationEditUX-FormField-218"
        },
        "inline": {
          "type": "value",
          "value": "true"
        },
        "width": {
          "type": "value",
          "value": "8"
        }
      },
      "seq": 218,
      "void": false
    },
    {
      "from": null,
      "id": 219,
      "name": "div",
      "parent": 217,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugResuscitationEditUX-div-219"
        }
      },
      "seq": 219,
      "void": false
    },
    {
      "from": null,
      "id": 220,
      "name": "div",
      "parent": 217,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugResuscitationEditUX-div-220"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\", padding: \"0px 10px\"}"
        }
      },
      "seq": 220,
      "void": false
    },
    {
      "from": null,
      "id": 221,
      "name": "div",
      "parent": 218,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugResuscitationEditUX-div-221"
        }
      },
      "seq": 221,
      "void": false
    },
    {
      "from": null,
      "id": 222,
      "name": "div",
      "parent": 218,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugResuscitationEditUX-div-222"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\", padding: \"0px 10px\"}"
        }
      },
      "seq": 222,
      "void": false
    },
    {
      "from": null,
      "id": 223,
      "name": "label",
      "parent": 219,
      "props": {
        "children": {
          "type": "value",
          "value": "Frequency",
          "valueEN": "Frequency"
        },
        "id": {
          "type": "value",
          "value": "CardDrugResuscitationEditUX-label-223"
        }
      },
      "seq": 223,
      "void": false
    },
    {
      "from": null,
      "id": 225,
      "name": "label",
      "parent": 221,
      "props": {
        "children": {
          "type": "value",
          "value": "วิธี",
          "valueEN": "Method"
        },
        "id": {
          "type": "value",
          "value": "CardDrugResuscitationEditUX-label-225"
        }
      },
      "seq": 225,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 226,
      "name": "Dropdown",
      "parent": 220,
      "props": {
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDrugResuscitationEditUX-Dropdown-226"
        },
        "name": {
          "type": "value",
          "value": "frequency"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "options": {
          "type": "code",
          "value": "props.masterOptions?.frequency"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.editData?.frequency || \"\""
        }
      },
      "seq": 226,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 227,
      "name": "Dropdown",
      "parent": 222,
      "props": {
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDrugResuscitationEditUX-Dropdown-227"
        },
        "name": {
          "type": "value",
          "value": "method"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "options": {
          "type": "code",
          "value": "props.masterOptions?.method"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.editData?.method || \"\""
        }
      },
      "seq": 227,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 80,
  "isMounted": false,
  "memo": false,
  "name": "CardDrugResuscitationEditUX",
  "project": "IsHealth",
  "screenPropsDefault": {
    "debug": true,
    "language": "EN",
    "showSupplyList": false
  },
  "width": 80
}

*********************************************************************************** */
